var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mgid-categories-dropdown-wrapper"},[_c('input',{ref:"MLDInput",attrs:{"type":"hidden"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }